/**
 * Helper function to get server base URL.
 * Centralised so all client code uses the same resolution logic.
 */
export const getServerBaseUrl = (): string => {
  if ((import.meta as any).env && (import.meta as any).env.VITE_SERVER_URL) {
    return (import.meta as any).env.VITE_SERVER_URL as string
  }

  if ((import.meta as any).env && (import.meta as any).env.DEV) {
    return 'http://localhost:2567'
  }

  const protocol = window.location.protocol
  const hostname = window.location.hostname

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:2567'
  }

  if (hostname === 'app.sevv.com') {
    return 'https://server.sevv.com'
  }

  if (hostname === 'app-stg.sevv.com') {
    return 'https://server-stg.sevv.com'
  }

  if (hostname.startsWith('app.')) {
    const serverHostname = hostname.replace('app.', 'server.')
    return `${protocol}//${serverHostname}`
  }

  return protocol === 'https:' ? `https://${hostname}:2567` : `http://${hostname}:2567`
}
